// extracted by mini-css-extract-plugin
export default {"container":"global_container__pU27b","categoriesList":"global_categoriesList__BusCi","visually_hidden":"global_visually_hidden__p8VcB"};